export const extendedDrawerWidth = 96
